<template>
  <v-app>
    <router-view />
    <notifications />
  </v-app>
</template>

<script setup>
import { onMounted } from "vue";
import localService from "./services/localService";
import { useAuthStore } from "./stores/auth";

// Store
const authStore = useAuthStore();

// Methods
const checkIfUserIsLoggedIn = () => {
  const userInfo = localService.getItem("breton-userInfo");
  const token = localService.getItem("breton-token");

  if (userInfo && token) {
    // Update Pinia store
    authStore.setState("currentUser", userInfo);
    authStore.setState("isLoggedIn", true);
  } else {
    // Update Pinia store
    authStore.setState("isLoggedIn", false);
  }
};

// Lifecycle hooks
onMounted(() => {
  checkIfUserIsLoggedIn();
});
</script>

<style lang="scss">
@use "@/assets/scss/global.scss";
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;1,6..12,200&display=swap");
</style>
